import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function I() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const items = [1, 2];
    const IMG1_MAP: any = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125585932/9_1.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125608981/9_1_M.png',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729060703898/175_de_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729060791066/175_de_h5.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729060702874/175_fr_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729060703153/175_fr_h5.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729060703401/175_es_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729060703590/175_es_h5.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729060702385/175_it_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729060791266/175_it_h5.png',
        },
        mx: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747052878752/175w-rigid-solar-panel.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747052970551/175w-rigid-solar-panel.png',
        },
    };
    const IMG1 = IMG1_MAP[locale] || IMG1_MAP.us;
    const IMGS = [
        IMG1,
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125660101/9_2.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125671392/9_2_M.png',
        },
    ];

    return (
        <div className={`sp-175w-I sp-175w-common ${css['sp-175w-I']}`}>
            <div className="info center">
                <p className="title">{t('I_title')}</p>
            </div>
            <div className="box header">
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-img">
                                <EFPicture src={IMGS[k].pc} srcPad={IMGS[k].h5} srcMobile={IMGS[k].h5} alt={t(`I_item${k + 1}`)} />
                            </div>
                            <p className="text">{t(`I_item${k + 1}`)}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box efficiency">
                <p className="label">{t('I_label_efficiency')}</p>
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <p className="text">
                                {t.rich(`I_item${k + 1}_efficiency`, {
                                    s: (txt: string) => <span className="s">{txt}</span>,
                                })}
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box size">
                <p className="label">{t('I_label_size')}</p>
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <p className="text">{t(`I_item${k + 1}_size`)}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box cost">
                <p className="label">{t('I_label_cost')}</p>
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <p className="text">{t(`I_item${k + 1}_cost`)}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box scenarios">
                <p className="label">{t('I_label_scenarios')}</p>
                <ul className="items">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <p className="text">{t(`I_item${k + 1}_scenarios`)}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
